export default __webpack_public_path__ + "static/media/隐私政策.9c30e306.pdf";